// extracted by mini-css-extract-plugin
module.exports = {"icon_holder":"index-module__icon_holder___ueBxa","icon_wrap":"index-module__icon_wrap___TXFGN","selected":"index-module__selected___Yyi8e","txt":"index-module__txt___wobVK"};